import { render, staticRenderFns } from "./about01.vue?vue&type=template&id=62678afe&scoped=true"
import script from "./about01.vue?vue&type=script&lang=js"
export * from "./about01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62678afe",
  null
  
)

export default component.exports